import { Layout } from "../../components/Layout";
import { Navbar } from "../../components/Navbar";
import { Billing } from "../../components/PagesContent/Billing";
import { NavigationBackground, NavigationTitle } from "../../components/NavigationTitle";
import { IconType } from "../../components/Icon";

export const BillingPage = () => {
  const topBar = (
    <NavigationTitle
      background={NavigationBackground.inherit}
      includeDivider={true}
      title="fees"
      iconName="arrowLeft"
      iconType={IconType.default}
    />
  );
  const navBar = <Navbar />;
  return (
    <Layout topBar={topBar} navBar={navBar} fixedTop={false} includeGaps={false}>
      <Billing />
    </Layout>
  );
};
